// src/ProductList.js
import React, { useState } from "react";
import { useTranslation } from "react-i18next"; // ✅ import translation hook
import "../Style/ProductList.css";
import { FaFacebook, FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import selfInkData from "../Data/selfInkData";
import heavyDutystampData from "../Data/heavyDutyStampData";
import InkBottleData from "../Data/inkBottleData";
import embosingStampData from "../Data/embosingStampData";
import numberingStampData from "../Data/numberingStampData";
import waxStampData from "../Data/waxStampData";
import electronicStampData from '../Data/electronicStampData';
import ordinaryStampData from '../Data/ordinaryStampData';
import datesStampingData from '../Data/DatesStampingData';
import pocketStampData from '../Data/PocketStampData';


const ProductList = () => {
   const { t } = useTranslation(); // ✅ translation hook
  const products = [...selfInkData, ...heavyDutystampData, ...InkBottleData,...embosingStampData,...numberingStampData,...waxStampData,...electronicStampData,...ordinaryStampData,...datesStampingData,...pocketStampData]; // Combine all product data arrays
  const [selectedCategory, setSelectedCategory] = useState("All");

  // 🔹 Filter Products by Category
  const filteredProducts =
    selectedCategory === "All"
      ? products
      : products.filter((p) => p.category === selectedCategory);

  // 🔹 WhatsApp Share
  const handleWhatsApp = (product) => {
    const msg = `Hello, I'm interested in: ${product.name} - ${product.description}`;
    const url = `https://wa.me/+971559139165?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="container mt-4" id="products">
      <h2 className="text-center mb-4 mt-5">{t("Our Products")}</h2>
      {/* 🔹 Dropdown Filter */}
      <div className="d-flex justify-content-center mb-4 option-list">
          <select
          className="form-select w-auto"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="All" class="date-option">{t("All Products")}</option>
          <option value="Automatic" class="date-option">{t("Automatic Self-ink Stamps")}</option>
          <option value="Heavy" class="date-option">{t("Heavy Duty Stamps")}</option>
          <option value="Embossing" class="date-option">{t("Embossing Stamps")}</option>
          <option value="Numbering" class="date-option">{t("Numbering Stamps")}</option>
          <option value="Wax" class="date-option">{t("Wax Stamps")}</option>
          <option value="Date" class="date-option">{t("Date Stamps")}</option>
            <option value="pocket" class="date-option">{t("Pocket Stamps")}</option>
          <option value="Ordinary" class="date-option">{t("Ordinary Stamps")}</option>
          <option value="electronic" class="date-option">{t("Electronic Stamps")}</option>
          <option value="Ink" class="date-option">{t("Ink for stamps")}</option>
        </select>
      </div>

      {/* 🔹 Product Grid */}
      <div className="row">
        {filteredProducts.map((product) => (
          <div className="col-md-3 mb-4" key={product.id}>
            <div className="card product-card   h-100">
              <img
                src={product.image}
                className="card-img-top product-img"
                 alt={t(product.name)}
              />
              <div
                className="card-body d-flex flex-column justify-content-between text-center"
                style={{ minHeight: "120px" }}
              >
                <h5 className="card-title" style={{ cursor: "pointer" }}>
                 {t(product.name)} 
                  <br />
                  <span className="text-muted mt-2 size-style">
                    {t("Size")} {t(product.size)}  {/* translate size dynamically */}
                  </span>
                </h5>

                {/* 🔹 Social Icons */}
                <div className="d-flex justify-content-around">
                  <FaFacebook
                    size={22}
                    style={{ cursor: "pointer", color: "#1877f2" }}
                    onClick={() =>
                      window.open(
                        `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
                        "_blank"
                      )
                    }
                  />
                  <FaPhoneAlt
                    size={22}
                    style={{ cursor: "pointer", color: "#0d6efd" }}
                    onClick={() => (window.location.href = "tel:+971559139165")} // <-- replace with your number
                  />
                  <FaWhatsapp
                    size={22}
                    style={{ cursor: "pointer", color: "#25d366" }}
                    onClick={() => handleWhatsApp(product)}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductList;
